import React from "react";
import { CUSTOMER_SEGMENTS } from "../constants";

export default function CustomerFields({
  customer,
  setCustomer,
  segment,
  setSegment,
  deliveryDate,
  setDeliveryDate,
  today,
  lookupLoading,
  shouldShowError,
  fieldErrors,
  handleBlur
}) {
  return (
    <div className="grid">
      <label>
        Phone
        <input
          value={customer.phone_number}
          onChange={(e)=>setCustomer({...customer, phone_number:e.target.value})}
          onBlur={() => handleBlur('phone_number')}
        />
        {lookupLoading && <span className="text-xs ml-2">Checking…</span>}
        {shouldShowError('phone_number') && <span className="text-xs text-red-600">{fieldErrors.phone_number}</span>}
      </label>
      <label>
        Name
        <input
          value={customer.name}
          onChange={(e)=>setCustomer({...customer, name:e.target.value})}
          onBlur={() => handleBlur('name')}
        />
        {shouldShowError('name') && <span className="text-xs text-red-600">{fieldErrors.name}</span>}
      </label>
      <label>Customer Segment
        <select value={segment} onChange={(e) => setSegment(e.target.value)}>
          {CUSTOMER_SEGMENTS.map(seg => (
            <option key={seg.value} value={seg.value}>{seg.label}</option>
          ))}
        </select>
      </label>
      <label>
        Email
        <input
          value={customer.email}
          onChange={(e)=>setCustomer({...customer, email:e.target.value})}
          onBlur={() => handleBlur('email')}
        />
        {shouldShowError('email') && <span className="text-xs text-red-600">{fieldErrors.email}</span>}
      </label>
      <label>
        Address
        <input
          value={customer.delivery_address}
          onChange={(e)=>setCustomer({...customer, delivery_address:e.target.value})}
          onBlur={() => handleBlur('delivery_address')}
        />
        {shouldShowError('delivery_address') && <span className="text-xs text-red-600">{fieldErrors.delivery_address}</span>}
      </label>
      <label>
        Area Code
        <input
          value={customer.area_code}
          onChange={(e)=>setCustomer({...customer, area_code:e.target.value})}
          onBlur={() => handleBlur('area_code')}
        />
        {shouldShowError('area_code') && <span className="text-xs text-red-600">{fieldErrors.area_code}</span>}
      </label>
      <label>
        City
        <input
          value={customer.city}
          onChange={(e)=>setCustomer({...customer, city:e.target.value})}
          onBlur={() => handleBlur('city')}
        />
        {shouldShowError('city') && <span className="text-xs text-red-600">{fieldErrors.city}</span>}
      </label>
      <label>
        District
        <input
          value={customer.district}
          onChange={(e)=>setCustomer({...customer, district:e.target.value})}
          onBlur={() => handleBlur('district')}
        />
        {shouldShowError('district') && <span className="text-xs text-red-600">{fieldErrors.district}</span>}
      </label>
      <label>
        State
        <input
          value={customer.state}
          onChange={(e)=>setCustomer({...customer, state:e.target.value})}
          onBlur={() => handleBlur('state')}
        />
        {shouldShowError('state') && <span className="text-xs text-red-600">{fieldErrors.state}</span>}
      </label>
      <label>
        Expected Delivery Date
        <input
          type="date"
          value={deliveryDate}
          onChange={(e)=>setDeliveryDate(e.target.value)}
          onBlur={() => handleBlur('delivery_date')}
          min={today}
          className="w-full"
        />
        {shouldShowError('delivery_date') && <span className="text-xs text-red-600">{fieldErrors.delivery_date}</span>}
      </label>
    </div>
  );
}

